import React from 'react';
import { useFeatureFlags } from 'feature-flags/useFeatureFlags';
import MainPublicRouter from './MainPublicRouter';
import TrainingPublicRouter from './TrainingPublicRouter';

const PublicRoutes: React.FC = () => {
  const { enableTrainingEnv } = useFeatureFlags();

  return enableTrainingEnv ? <TrainingPublicRouter /> : <MainPublicRouter />;
};

export default PublicRoutes;
